import React from "react";
import moment from "moment";
import {
  strings,
  fetchOtherNewsCardImage,
  capitalizeString,
} from "../../../Helpers";
import PharmacyIcon from "../../../images/pharmacy-icon.svg";
import { SaveNewsView } from "./SaveNewsView";

const NewsOtherTypesCard = ({
  newsArticle,
  handleSaveUnsaveArticle,
  handleShareNewsArticle,
  redirectUserToNews,
  fromDetail,
  hideSave,
}) => {
  return (
    <div className="home-card news-card">
      <div className="news-type-top">
        {/* news source details :Start */}
        <div className="news-source-details">
          {newsArticle.news_type === "PHARMA" ? (
            <div className={`news-logo no-border news-logo-box pharma-icon-bg`}>
              <img src={PharmacyIcon} alt="pharmacy_icon" />
            </div>
          ) : (
            <div
              className={`news-logo no-border ${
                fetchOtherNewsCardImage(newsArticle.news_type).sourceUrlClass
              }`}
              style={{
                backgroundImage: `url('${
                  fetchOtherNewsCardImage(newsArticle.news_type).sourceUrl
                }')`,
              }}
            ></div>
          )}

          <div className="news-source-info">
            <div className="news-type">
              {newsArticle.news_type !== "COVID19"
                ? capitalizeString(newsArticle.news_type)
                : newsArticle.news_type}
            </div>
          </div>
        </div>
        {!newsArticle.photo_url && (
          <div className="news-divider mx-0 mt-10"></div>
        )}

        {/* news source details :End */}
      </div>
      {newsArticle.photo_url && (
        <div
          className="news-image square-border mt-15"
          style={{
            backgroundImage: `url('${newsArticle.photo_url}')`,
          }}
          onClick={() => redirectUserToNews(newsArticle, "News Image")}
        >
          {newsArticle.news_label && (
            <span className="news_label">{`${newsArticle.news_label}`}</span>
          )}
        </div>
      )}

      <div className="news-detail-wrapper">
        <div className="d-flex pl-20 prx-20 space-between">
          <div className="news-source-name mb-8">
            {newsArticle.news_type === "PHARMA"
              ? newsArticle.title
              : newsArticle.source_name}
          </div>

          {/* {!fromDetail && !hideSave && (
            <SaveNewsView
              newsArticle={newsArticle}
              handleSaveUnsaveArticle={handleSaveUnsaveArticle}
            />
          )} */}
        </div>
        <div
          className="news-heading"
          onClick={() => redirectUserToNews(newsArticle, "News Headline")}
        >
          {newsArticle.title}
        </div>

        <div className="news-text-wrap">
          <div className={`news-text ${fromDetail ? "show-full-text" : ""}`}>
            {newsArticle.news_text}
          </div>
        </div>
        <div className="news-source-details">
          <div className="news-date">
            {moment(newsArticle.news_date).format("DD MMM")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsOtherTypesCard;
